/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SafetyHistoryDto } from '../../models/safety-history-dto';

export interface GetHistory$Params {

/**
 * safetyId
 */
  id: number;
  customerGUID: string;
}

export function getHistory(http: HttpClient, rootUrl: string, params: GetHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<SafetyHistoryDto>> {
  const rb = new RequestBuilder(rootUrl, getHistory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SafetyHistoryDto>;
    })
  );
}

getHistory.PATH = '/safeties/{id}/history';
